import CasinoListItem from "./item";
import React, {useCallback, useEffect, useMemo, useState} from "react";
import associateServices from "../../services";
import {debounce} from "lodash";
import {useTranslation} from "react-i18next";
import SkeletonCasinoGroupGameItem from "../../components/skeleton/casino-group-item";
import SvgIcon from "../../components/svg-icon";
import NoData from "../../components/no-data";
import StyleHelper from "../../helpers/styleHelper";
import {useSelector} from "react-redux";

const SearchResults = (props) => {

    const {type = null, providers = []} = props

    const {t} = useTranslation()
    const [search, setSearch] = useState('')
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([])
    const [coloredData, setColoredData] = useState([])
    const {configuration} = useSelector(state => state.globalReducer)

    useEffect(() => {
        setColoredData(data?.map(oo => ({
            ...oo,
            color: oo.color === 'random' ? StyleHelper.getRandomColor() : oo.color
        })))
    }, [data])


    useEffect(() => {

        setData([])
        setSearch('')
    }, [window?.location?.pathname])
    const sendRequest = useCallback((name) => {
        setLoading(true)

        associateServices.searchGames({name, type, providers}).then(res => {
            setData(res?.data || [])
            setLoading(false)
        })
    }, [type, providers]);


    const debouncedSendRequest = useMemo(() => {
        return debounce(sendRequest, 500);
    }, [sendRequest]);

    const onChange = (e) => {
        setData([])
        setSearch(e.target.value);
        if (e?.target?.value?.length >= 3) {
            setLoading(true)
            debouncedSendRequest(e.target.value);
        }
    }


    return (

        <div className="col-12">
            <div className="filter">
                {/*<button className="filter__btn" type="button">*/}
                {/*    <i className="ti ti-filter-cog"/>*/}
                {/*    {t('casino.filter')}*/}
                {/*</button>*/}
                <div className="filter__search filter__search--big mb-0">
                    <div className="search">
                        <input
                            value={search}
                            onChange={onChange}
                            name="search"
                            type="search"
                            className="search__input" placeholder={t('casino.search', 'Sarch')}/>
                        <button className="search__btn" type="button">
                            <SvgIcon id={'search'}/>
                        </button>
                    </div>
                </div>

                {
                    search &&
                    <div className="section section--last pt-24 modal-fade">
                        <div className="container">
                            <div className="row mh-400">
                                {
                                    loading ? Array.from({length: 14}).map((_, index) => (
                                        <div className="col-6 col-slot" key={index}>
                                            <SkeletonCasinoGroupGameItem secondary={true}/>
                                        </div>
                                    )) : data?.length <= 0 ?
                                        <div className="col-12">
                                            <NoData
                                                desc={t('general.type-at-least-3-letters', 'Search requires at least 3 characters.')}/>
                                        </div> :
                                        coloredData?.map((game, i) => <CasinoListItem
                                            passive={game?.blacklist?.includes(configuration.country)}
                                            key={i}
                                            index={i}
                                            game={game}
                                        />)
                                }
                            </div>
                        </div>
                    </div>
                }
            </div>

        </div>

    )
}

export default SearchResults
